import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { DeleteLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/location/delete-location.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useDeleteLocationContext } from '../../location.context';
import { LocationDeleteFormStep1Controller } from '../location-delete-form-step-1/location-delete-form-step-1.controller';

export interface LocationDeleteFormControllerProps {
  onError: SubmitErrorHandler<Pick<DeleteLocationModel, 'id'>>;
  onSubmit: SubmitHandlerWithDirtyFields<Pick<DeleteLocationModel, 'id'>>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const LocationDeleteFormController = (
  props: LocationDeleteFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useDeleteLocationContext();

  return (
    <MultiStepFormProvider<Pick<DeleteLocationModel, 'id'>>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['id'],
          component: <LocationDeleteFormStep1Controller />,
        },
      ]}
    />
  );
};
